const copyrightNoticeYearRange = (startYear) => {
  // In case the input was not a number (nil.to_i will return a 0)
  const parsedStartYear = parseInt(startYear, 10);
  // Get the current year from the system
  const currentYear = new Date().getFullYear();
  // When the current year is more recent than the start year, return a string
  // of a range (e.g., 2010 - 2012). Alternatively, as long as the start year
  // is reasonable, return it as a string. Otherwise, return the current year
  // from the system.
  if (currentYear > parsedStartYear && parsedStartYear > 2000) {
    return `${parsedStartYear} - ${currentYear}`;
  }
  if (parsedStartYear > 2000) {
    return parsedStartYear.toString();
  }
  return currentYear.toString();
};
export default copyrightNoticeYearRange;
